export const useClientStore = defineStore("client", () => {
  // States
  const isIOS = ref(false);
  const isStandalone = ref(false);

  return {
    isIOS,
    isStandalone,
  };
});
